<template>
  <div class="app-container">
    <el-form label-position="top" size="small">
      <el-row :gutter="20">
        <el-col span="7">
          <!--创建时间-->
          <el-form-item :label="$t('newOrder.createTime')">
            <el-date-picker
              v-model="timeValue"
              :clearable="true"
              :default-time="['00:00:00', '23:59:59']"
              :format="$i18n.locale == 'zh' ? zhDate : ptDate"
              :placeholder="$t('newOrder.SelectDatetime')"
              range-separator="~"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col span="5">
          <!--   创建人   -->
          <el-form-item :label="$t('GlobalSetObj.CreatePeople')">
            <el-select
              v-model="queryForm.params.createUser"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              :remote-method="getUserManageOption"
              clearable
              filterable
              remote
              reserve-keyword
              style="width: 100%"
              @visible-change="handleUserManageOption"
            >
              <el-option
                v-for="item in createrList"
                :key="item.id"
                :label="item.realName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="5">
          <!--  消息类型   -->
          <el-form-item :label="$t('customerManagements.messageType')">
            <el-select v-model="queryForm.params.messageType" style="width: 100%">
              <el-option key="-1" :label="$t('GlobalSetObj.all')" :value="0" />
              <el-option key="0" :label="$t('GlobalSetObj.sysNameInfo')" :value="1" />
              <el-option key="1" :label="$t('GlobalSetObj.announcement')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="7">
          <el-form-item label="" style="margin-top: 28px">
            <!--搜索-->
            <el-button
              icon="el-icon-search" type="primary" @click="enterSearch"
            >{{ $t('newOrder.search') }}
            </el-button>
            <!--重置-->
            <el-button
              icon="el-icon-refresh-left" type="info" @click="resetForm()"
            >{{ $t('newOrder.reset') }}
            </el-button>
            <el-button
              style="margin-bottom: 10px" type="primary" @click="newMessage"
            >{{ $t('customerManagements.add') }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--  表格数据  -->
    <el-table :data="tableData" border style="width: 100%">
      <!--创建时间-->
      <el-table-column :label="$t('newOrder.createTime')" min-width="150" prop="createDate" />
      <!--系统-->
      <el-table-column :label="$t('GlobalSetObj.system')" min-width="110" prop="systemTypeData" />
      <!--用户端-->
      <el-table-column
        :label="$t('customerManagements.userSide')"
        min-width="90"
        prop="clientTypeData"
      />
      <!--消息类型-->
      <el-table-column
        :label="$t('customerManagements.messageType')"
        min-width="120"
        prop="messageNoticeTypeStr"
      />
      <!--接收对象-->
      <el-table-column
        :label="$t('customerManagements.acceptObject')"
        min-width="150"
        prop="providerNames"
      />
      <!-- 警告次数 -->
      <el-table-column :label="$t('spareNumberPoo.warningCount')" min-width="130" prop="msgCount" />
      <!--标题-->
      <el-table-column
        :label="$t('customerManagements.headline')"
        min-width="200"
        prop="title"
        show-overflow-tooltip
      />
      <!--内容-->
      <el-table-column
        :label="$t('customerManagements.content')"
        min-width="150"
        prop="msgDataContent"
      >
        <template slot-scope="scope">
          <div class="verifier" @click="seeDetail(scope.row.msgDataContent)">
            {{ $t('home.clickSee') }}
          </div>
        </template>
      </el-table-column>
      <!--创建人-->
      <el-table-column :label="$t('GlobalSetObj.CreatePeople')" min-width="160" prop="createName" />
      <!-- 操作 -->
      <el-table-column :label="$t('jobManagement.operation')" fixed="right" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.msgType === 9" class="flx-around">
            <el-tooltip
              v-if="scope.row.topType === 0"
              :content="$t('spareNumberPoo.pinToTop')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="iconfont icon-a-ziyuan36 textOperator1" @click="isToTop(scope.row)" />
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.topType === 1"
              :content="$t('spareNumberPoo.unpinFromTop')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="iconfont icon-a-ziyuan53 textOperator" @click="isToTop(scope.row)" />
            </el-tooltip>
            <el-tooltip
              v-show="scope.row.noticeStatus === 0"
              :content="$t('GlobalSetObj.enable')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-circle-check textOperator1" @click="disableData(scope.row, 1)" />
            </el-tooltip>
            <el-tooltip
              v-show="scope.row.noticeStatus === 1"
              :content="$t('GlobalSetObj.stop')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-remove-outline textOperator2" @click="disableData(scope.row, 0)" />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.number"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <el-drawer
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('customerManagements.newcontent')"
      :visible.sync="isNewMessageDialog"
      class="drawerClass"
      direction="ltr"
      size="1000px"
    >
      <newMessage v-if="isNewMessageDialog" ref="newMessageRef" @child-event="parentMethod" />
    </el-drawer>
    <!-- 图片预览 -->
    <ElImageViewer v-if="showViewer" :on-close="closeViewer" :url-list="imgArr" />
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('spareNumberPoo.messageContent')"
      :visible.sync="messageDialog"
      top="5vh"
    >
      <div
        style="height: 700px; overflow-y: auto"
        @click.stop="getImgSrc"
        v-html="msgDataContent"
      />
    </el-dialog>
  </div>
</template>

<script>
import { cancelTopMessageById, selectProviderMessage, topMessageById, updateNoticeStatus } from '@/api/orderApi';
import dayjs from 'dayjs';
import { query10User } from '@/api/lanshou';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';

export default {
  name: 'SystemMessages',
  components: {
    newMessage: () => import('./component/newMessage.vue'),
    ElImageViewer
  },
  data() {
    return {
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      queryForm: {
        pageSize: 10,
        number: 1,
        total: 0,
        params: {
          createUser: null,
          messageType: 0
        }
      },
      tableData: [],
      createrList: [],
      providerList: [],
      siteList: [],
      accountList: [],
      isNewMessageDialog: false,
      showViewer: false,
      imgArr: [],
      messageDialog: false,
      msgDataContent: ''
    };
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    this.getUserManageOption();
    this.getSearch();
  },
  methods: {
    // 点击查看内容
    seeDetail(row) {
      console.log(row, 'seeDetail');
      if (row) {
        this.msgDataContent = row;
        this.messageDialog = true;
      }
    },
    // 查看图片
    getImgSrc(e) {
      if (e.target.nodeName !== 'IMG') {
        return;
      }
      this.imgArr = [e.target.src];
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    // 去置顶
    isToTop(row) {
      console.log(row, 'isToTop');
      if (row.topType === 0) {
        topMessageById(row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success(this.$t('spareNumberPoo.pinSuccess'));
            this.getSearch();
          }
        });
      } else {
        cancelTopMessageById(row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success(this.$t('spareNumberPoo.unpinSuccess'));
            this.getSearch();
          }
        });
      }
    },
    disableData(row) {
      const typeText =
        row.noticeStatus === 0
          ? this.$t('basicData.AreYouSureEnabled')
          : this.$t('ChannelManage.sureToStop');
      this.$confirm(typeText, this.$t('GlobalSetObj.tips'), {
        confirmButtonText: this.$t('GlobalSetObj.determine'), // '确定',
        cancelButtonText: this.$t('orderCenterCont.cancel'), // '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          id: row.id, // id
          noticeStatus: row.noticeStatus ? 0 : 1 // 0:停用,1:启用
        };
        updateNoticeStatus(data).then((res) => {
          if (res.code === 200) {
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            this.getSearch();
          }
        });
      });
    },
    parentMethod() {
      console.log('parentMethod');
      this.isNewMessageDialog = false;
      this.enterSearch();
    },
    enterSearch() {
      this.queryForm.number = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.number = 1;
      this.getTimer();
      this.queryForm.params = {
        createUser: null,
        messageType: 0
      };
      this.getSearch();
    },
    newMessage() {
      this.isNewMessageDialog = true;
    },
    // 查询
    getSearch() {
      const data = {
        params: {}
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.number;
      data.params = { ...this.queryForm.params };
      if (this.timeValue && this.timeValue.length > 0) {
        data.params.createStartTime = this.timeValue[0];
        data.params.createEndTime = this.timeValue[1];
      }
      selectProviderMessage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
          this.tableData.forEach((item) => {
            if (item.msgData) {
              item.msgDataContent = item.msgData.replace(/<p>/g, '<p style="margin: 0;">');
            }
          });
        }
      });
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.number = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.number = val;
      this.getSearch();
    },
    // 获取最近一星期时间
    getTimer() {
      const today = dayjs().format('YYYY-MM-DD');
      const oneWeekAgo = dayjs().subtract(1, 'week').format('YYYY-MM-DD');
      this.timeValue = [oneWeekAgo + ' 00:00:00', today + ' 23:59:59'];
    },
    // 获取入库人选项
    getUserManageOption(val = '') {
      query10User(val).then((res) => {
        if (res.code === 200) {
          this.createrList = res.data;
        }
      });
    },
    handleUserManageOption(val) {
      if (val) {
        this.getUserManageOption();
      }
    }
  }
};
</script>

<style scoped>
.sle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.textOperator {
  color: #409eff;
  font-size: 20px;
  cursor: pointer;
}

.textOperator1 {
  color: #409eff;
  cursor: pointer;
  font-size: 20px;
}

.textOperator2 {
  color: #f56c6c;
  cursor: pointer;
  font-size: 20px;
}

.verifier {
  color: #409eff;
  cursor: pointer;
  font-size: 14px;
}
</style>
